import { render } from "./Mapbox.vue?vue&type=template&id=268766b5"
import script from "./Mapbox.vue?vue&type=script&lang=js"
export * from "./Mapbox.vue?vue&type=script&lang=js"

import "./Mapbox.vue?vue&type=style&index=0&id=268766b5&lang=css"
script.render = render

export default script